import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiParameters } from 'src/app/configs/api.params';

/**
 * @ignore
 */
@Injectable({
  providedIn: 'root',
})
export class LogoService {
  constructor(private httpClient: HttpClient) {}

  // Global
  getLogos(): Observable<any> {
    return this.httpClient.get(`${apiParameters.url}/logos`).pipe(
      map((res: any) => {
        res.data.sort((a, b) => {
          return (
            (new Date(b.createdAt) as any) - (new Date(a.createdAt) as any)
          );
        });
        return res.data;
      })
    );
  }

  addLogo(body: FormData): Observable<any> {
    return this.httpClient.post(`${apiParameters.url}/logos`, body);
  }

  updateLogo(body: FormData, logoId: string): Observable<any> {
    return this.httpClient.patch(`${apiParameters.url}/logos/${logoId}`, body);
  }

  deleteLogo(logoId: string): Observable<any> {
    return this.httpClient.delete(`${apiParameters.url}/logos/${logoId}`);
  }

  // Customer
  getCustomerLogos(customerId: string): Observable<any> {
    return this.httpClient
      .get(`${apiParameters.url}/customers/${customerId}/logos`)
      .pipe(
        map((res: any) => {
          res.sort((a, b) => {
            return (
              (new Date(b.createdAt) as any) - (new Date(a.createdAt) as any)
            );
          });
          return res;
        })
      );
  }

  addLogoToCustomer(customerId: string, body: any): Observable<any> {
    return this.httpClient.post(
      `${apiParameters.url}/customers/${customerId}/logos`,
      body
    );
  }

  deleteLogoFromCustomer(customerId: string, logoId: string): Observable<any> {
    return this.httpClient.delete(
      `${apiParameters.url}/customers/${customerId}/logos/${logoId}`
    );
  }

  // Client
  getClientLogos(clientId: string): Observable<any> {
    return this.httpClient
      .get(`${apiParameters.url}/clients/${clientId}/logos`)
      .pipe(
        map((res: any) => {
          res.sort((a, b) => {
            return (
              (new Date(b.createdAt) as any) - (new Date(a.createdAt) as any)
            );
          });
          return res;
        })
      );
  }

  addLogoToClient(clientId: string, body: any): Observable<any> {
    return this.httpClient.post(
      `${apiParameters.url}/clients/${clientId}/logos`,
      body
    );
  }

  deleteLogoFromClient(clientId: string, logoId: string): Observable<any> {
    return this.httpClient.delete(
      `${apiParameters.url}/clients/${clientId}/logos/${logoId}`
    );
  }

  // User
  getUserLogos(userId: string): Observable<any> {
    return this.httpClient.get(`${apiParameters.url}/users/${userId}/logos`);
  }

  addLogoToUser(userId: string, body: any): Observable<any> {
    return this.httpClient.post(
      `${apiParameters.url}/users/${userId}/logos`,
      body
    );
  }

  deleteLogoFromUser(userId: string, logoId: string): Observable<any> {
    return this.httpClient
      .delete(`${apiParameters.url}/users/${userId}/logos/${logoId}`);
  }
}
